import { useQuery } from '@tanstack/react-query';
import DeficienciesService from '../services/DeficienciesService';
// Query Keys for deficiencies
export const DEFICIENCIES_QUERY_KEYS = {
    all: ['customer-portal-deficiencies'],
    filter: (params) => ['customer-portal-deficiencies', 'filter', params.page, params.sort, params.filters],
    detail: (id) => ['customer-portal-deficiencies', 'detail', id]
};
export function useDeficiencies(params) {
    return useQuery({
        queryKey: DEFICIENCIES_QUERY_KEYS.filter(params),
        queryFn: () => DeficienciesService.getDeficiencies(params),
        staleTime: 2 * 60 * 1000,
        retry: 3,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });
}
export function useDeficiencyDetail(id) {
    return useQuery({
        queryKey: DEFICIENCIES_QUERY_KEYS.detail(id),
        queryFn: () => DeficienciesService.getDeficiency(id),
        enabled: !!id,
        staleTime: 5 * 60 * 1000,
        retry: 2
    });
}
